export const formules = [
  {
    nom: "Basique",
    code: "basique",
    prix: 900,
    ia: false,
    modules: {
      emploiDuTemps: true,
      carnet: true,
      messagerie: true,
      suiviMedical: false,
      budget: false,
      rh: false
    },
    limites: {
      utilisateursMax: 28,
      stockageMo: 500
    }
  },
  {
    nom: "Premium",
    code: "premium",
    prix: 1170,
    ia: true,
    modules: {
      emploiDuTemps: true,
      carnet: true,
      messagerie: true,
      suiviMedical: true,
      budget: true,
      rh: true
    },
    limites: {
      utilisateursMax: 50,
      stockageMo: 1000
    }
  },
  {
    nom: "IA",
    code: "ia",
    prix: 1625,
    ia: true,
    modules: {
      emploiDuTempsIA: true,
      suiviIA: true,
      recommandations: true,
      budget: true,
      rh: true
    },
    limites: {
      utilisateursMax: 100,
      stockageMo: 5000
    }
  }
];
